export const Endcap = props => (
  <marker
    id={`endcap-${props.position}-${props.uniqueId}`}
    viewBox={props.viewBox}
    refX={props.refX}
    refY={props.refY}
    markerWidth={props.markerWidth}
    markerHeight={props.markerHeight}
    orient="auto"
    overflow="visible"
  >
    <path
      d={props.path}
      fill={props.fill}
      stroke={props.color}
      stroke-linecap={props.strokeLinecap}
      stroke-linejoin={props.strokeLinecap}
      stroke-width={2}
    />
  </marker>
);
